<div class="first-part">
  <div class="left">
    <div class="title text1">携手同行</div>
    <div class="title text2">共赢未来</div>
    <div class="text3">诚邀优质供应商合作伙伴</div>
  </div>
  <div class="right">
    <img src="../../../assets/images/cooperate/top-img.webp" alt="" />
  </div>
</div>
<div class="content">
  <div class="second-part">
    <div class="title">尊敬的合作伙伴</div>
    <div class="text">
      我们是一家专注于全球优质互联网服务的一站式合租平台，现因业务拓展需求，面向全国/全球长期招募优质供应商合作伙伴。诚邀具备生产/供应实力的伙伴携手共赢，共同开拓市场。
    </div>
  </div>
  <div class="divider">
    <span class="line"></span><span class="title">合作需求</span>
    <span class="line"></span>
  </div>
  <div class="third-part">
    <div class="item" *ngFor="let item of thridPartList">
      <img [src]="item.img" alt="" />
      <div class="item-1" [ngStyle]="{ color: item.color }">
        {{ item.title }}
      </div>
      <div class="item-2">
        {{ item.text }}
      </div>
    </div>
  </div>
  <div class="forth-part">
    <div class="title">您将获得</div>
    <div class="detail">
      <div class="item" *ngFor="let item of forthPartList">
        <img src="../../../assets/images/cooperate/forth-part.webp" alt="" />
        <span>{{ item.text }}</span>
      </div>
    </div>
  </div>
  <div class="divider">
    <span class="line"></span><span class="title">联系方式</span>
    <span class="line"></span>
  </div>
  <div class="fifth-part">
    <div class="subtitle">请将以下资料发送至邮箱：</div>
    <div class="detail">
      <div class="item" *ngFor="let item of fifthPartList">
        <img [src]="item.img" alt="" />
        <div class="text">{{ item.text }}</div>
      </div>
    </div>
    <div class="subtitle">联系方式</div>
    <div class="tell">
      <img src="../../../assets/images/cooperate/fifith-part-4.webp" alt="" />
      <span>邮箱地址：huangzhipeng4600@gmail.com</span>
      <img
        class="qrcode"
        src="../../../assets/images/cooperate/qrcode.webp"
        alt=""
      />
    </div>
  </div>
  <div class="tip">
    注：我们将于3个工作日内审核资料并安排专人对接，期待与您共建可持续供应链生态！
  </div>
</div>
